module.exports = __webpack_public_path__ + "img/solution_building5.b70bc40e.png";